// add and edit the todo in a React MUI drawer
import * as React from 'react';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Divider from '@mui/material/Divider';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useTheme, useMediaQuery } from '@mui/material';
import DateTodoTodo from './dateToDoToDoTimePicker';
import NotesPresenter from './notesPresenter';
import PurpleButton from '../common/buttonTheme';
import PercentToDoDone from "./percent_done";
import CloseIcon from '@mui/icons-material/Close';
import useDrawerHistory from '../hooks/useDrawerHistory';
import ConversationView from './ConversationView';

const TodoDrawer = ({
  drawerOpen,
  onTitleChange,
  onDescriptionChange,
  saveTodo,
  title,
  listName,
  onListNameChange,
  description,
  dateTimeToDoToDo,
  onDateToDoToDoChange,
  closeDrawer,
  isEdited,
  notes,
  onNotesChange,
  percentDone,
  setPercentDone,
  listNames,
  todoId,
  responders,
  conversation,
  onConversationUpdate,
  isDone,
  onIsDoneChange,
}) => {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  // Responsive width: full width on mobile, 90% on tablet, 50% on desktop
  const drawerWidth = isMobile ? '100%' : isTablet ? '90%' : '50%';

  // Manage browser history for back button behavior
  useDrawerHistory(drawerOpen, () => closeDrawer(false), 'todo-drawer');

  return (
    <SwipeableDrawer
      anchor="right"
      open={drawerOpen}
      onClose={()=>{}}
      onOpen={()=>{}}
      PaperProps={{
        sx: { width: drawerWidth },
      }}
    >

      <Box
        display="flex"
        flexDirection="column"
        width="100%"
        boxShadow={6}
        padding={isMobile ? 2 : 3}
        gap={1}
      >

        <Box
          sx={{display: "flex", justifyContent: "flex-end", cursor:"pointer"}}
          data-testid="close-icon-wrapper"
          onClick={() => closeDrawer(false)}
        >
          <CloseIcon data-testid="close-icon"/>
        </Box>

        <Autocomplete
          freeSolo
          options={listNames}
          value={listName}
          onChange={(event, newValue) => {
            onListNameChange({ target: { value: newValue } });
          }}
          onInputChange={(event, newValue) => {
            onListNameChange({ target: { value: newValue } });
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="List Name"
              variant="outlined"
              fullWidth
            />
          )}
        />

        <TextField
          variant="outlined"
          onChange={onTitleChange}
          label="The title of your task"
          value={title}
          fullWidth
        />

        <TextField
          variant="outlined"
          onChange={onDescriptionChange}
          label="describe your task"
          value={description}
          fullWidth
          multiline
          minRows={5}
        />

        <PercentToDoDone {...{ percentDone, setPercentDone}} />
        <DateTodoTodo {... {dateTimeToDoToDo, onDateToDoToDoChange} } />

        {/* Mark as Done checkbox - only show when editing */}
        {isEdited && onIsDoneChange && (
          <Box sx={{ my: 2, p: 1, border: '1px solid #ccc', borderRadius: 1 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isDone || false}
                  onChange={(e) => onIsDoneChange(e.target.checked)}
                  color="primary"
                />
              }
              label="Mark as done"
            />
          </Box>
        )}

        <NotesPresenter {... {notes, onNotesChange} } />

        {/* Show conversation when editing and has multiple responders */}
        {isEdited && responders && responders.length > 1 && (
          <>
            <Divider sx={{ my: 2 }} />
            <ConversationView
              todoId={todoId}
              conversation={conversation}
              responders={responders}
              onMessageAdded={onConversationUpdate}
            />
          </>
        )}

        <PurpleButton
          size="large"
          variant="contained"
          onClick={saveTodo}
          sx={{ marginLeft: 1, mt: 2 }}
        >
          {isEdited ? "Save Todo" : "Add Todo"}
        </PurpleButton>

      </Box>

    </SwipeableDrawer>
  )
}

export default TodoDrawer;